import { styled } from 'styled-components'
import { Link } from '@remix-run/react'

export const RouteLink = styled(Link)`
  text-decoration: none;
  color: unset;
`
